import React, {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useKeycloak} from "@react-keycloak/web";
import * as yup from "yup";
import {useForm} from "common/src/hooks/form/formHook";
import {UserContext} from "../../context/UserContext";
import PromiseBuilder from "common/src/utils/PromiseUtils";
import ApiClient from "common/src/api/ApiClient";
import Input from "common/src/components/widget/Input";
import Button from "common/src/components/widget/Button";
function UserProfile() {
  const {user} = useContext(UserContext);

  const {t} = useTranslation();
  const keycloakInstance = useKeycloak();

  const [isLoading, setIsLoading] = useState(false);

  const schema = {
    firstName: yup.string().max(255, t('length_exceeded_error')).required(t('required_field')),
    lastName: yup.string().max(255, t('length_exceeded_error')).required(t('required_field')),
  };

  const {
    values,
    getField,
    handleSubmit,
    setValue,
  } = useForm(submit, {}, schema);

  useEffect(() => {
    if (user.firstName && user.lastName) {
      setValue('firstName', user.firstName);
      setValue('lastName', user.lastName);
    }
  }, [user])

  function submit() {
    const requestData = {
      firstName: values.firstName,
      lastName: values.lastName,
    }

    setIsLoading(true);
    new PromiseBuilder()
      .then(async () => ApiClient.put(`/api/v1/profile/${user.id}`, requestData))
      .finally(async () => setIsLoading(false))
      .finally(async () => keycloakInstance.keycloak.login({}))
      .run();
  }

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="card">
          <header className="card-header">
            <p className="card-header-title">
              <span className="icon fz fz-user medium mr-1"/>
              <span>{t('user_profile.user_info')}</span>
            </p>
          </header>
          <div className="card-content">
            <div className="columns">
              <div className="column is-half">
                <Input label={t('user.firstName')}
                       formField={getField("firstName")}/>
                <Input className='mt-5' label={t('user.lastName')}
                       formField={getField("lastName")}/>
                <Button
                  className='fz fz-lock medium change-password-btn'
                  onClick={() => keycloakInstance.keycloak.login({action: "UPDATE_PASSWORD"})}
                  color="primary"
                  isOutlined={true}
                  label={t('user_profile.change_password')}
                />
              </div>
            </div>
          </div>
        </div>
        <Button color="primary" label={t('save')} isSubmit={true}
                isLoading={isLoading}/>
        {/*<div className="level-right">*/}
        {/*</div>*/}
      </form>
    </>
  );
}

export default UserProfile;
